import { render, staticRenderFns } from "./TOPIC.vue?vue&type=template&id=30eada1b&scoped=true&"
import script from "./TOPIC.vue?vue&type=script&lang=js&"
export * from "./TOPIC.vue?vue&type=script&lang=js&"
import style0 from "./TOPIC.vue?vue&type=style&index=0&id=30eada1b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eada1b",
  null
  
)

export default component.exports